import { useEffect, useMemo, useState } from "react";
import MaterialReactTable from 'material-react-table';
import axios from "axios";
import { BASE_URL } from "ApplicationURI";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField,  Typography } from "@mui/material";
import { Form } from "react-bootstrap";
import { request } from "components/axiosconfig";
import { Delete } from "@mui/icons-material";
import { GET_VIEWSFEEDBACK_DETAILS } from "ApplicationURI";
import { ADD_VIEWSFEEDBACK } from "ApplicationURI";
import { useForm, Controller } from 'react-hook-form';
import { EDIT_VIEWSFEEDBACK } from "ApplicationURI";
import { DELETE_VIEWSFEEDBACK } from "ApplicationURI";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function ViewsFeedback() {
  const [response,setResponse] = useState([])
  const [open, setOpen] = useState(false);

  const { control, handleSubmit,reset, formState: { errors }} = useForm( );
  const [errorMessage, setErrorMessage] = useState('');
const [openSnackbar, setOpenSnackbar] = useState(false);
 

  const handleAddSubmit=(data)=>{
    console.log("this is adddddddd");
    // e.preventDefault();
    const postData={
      rating:data.rating,
      feedBack:data.feedBack,
      name:data.name,
      designation:data.designation
    }
    console.log("thiss is adddd data"+JSON.stringify(data) );

    request({url:ADD_VIEWSFEEDBACK, method:"post", data:postData }).then(res=>{
      console.log(res);
      if(res.status===200){
      handleAddClose();
      viewsandFeedback();
      reset()

          }
    }).catch(error=>{
      console.log(error.response); // Log the error response object
      if (error.response) {
        // Request was made and server responded with a status code
        console.log("error.response.status" + error.response.status);
        console.log("fhgfhgf" + error.response.data.message);

        if (error.response.status !== 200 || error.response.status !== 201) {
          setErrorMessage(error.response.data.message);
          setOpenSnackbar(true);
        }
      } else if (error.request) {
        
        console.log(error.request);
      } else {
      
        console.log('Error', error.message);
      }
    });
  }

  const handleSaveRow = ({ row, values,exitEditingMode}) => {
    const requiredFields= ['rating','feedBack','name','designation'];
    const missingFields = requiredFields.filter((field) =>
      !values[field]);
      if(missingFields.length > 0){
        alert(`Please fill in the following required fields: ${missingFields.join(', ')}`);
  return;
      }

      // const rating = parseInt(values.rating);
      // if (isNaN(rating) || rating < 1 || rating > 5) {
      //   alert('Rating should be a number between 1 and 5');
      //   return;
      // }


      const rating = parseFloat(values.rating); // changed from parseInt to parseFloat
      if (isNaN(rating) || rating < 1 || rating > 5 || rating % 1 !== 0) { // added "rating % 1 !== 0" check
          alert('Rating should be a whole number between 1 and 5. Point values are not accepted.');
          return;
      }

    console.log("aishuuuuuuuuuuu testtttttttt" + row.original.id);
    console.log(values);
    if (!values) {
      return;
    }
  const data={
   rating:values.rating,
   feedBack:values.feedBack,
   name:values.name,
   designation:values.designation
  }
       
    request({url:`${EDIT_VIEWSFEEDBACK}${row.original.id}`, method:"put", data:data}).then(res=>{
        
        const updatedData = [...response]
        updatedData[row.index] = res.data
        setResponse(updatedData)
        exitEditingMode();
     
      })
      .catch(error => {
        console.log(error)
      })
  }

  function handleDelete(data) {
    window.alert('Are you sure you want to delete this Views&Feedback?');
    console.log(data.original.id);
    console.log("this is delete inside");
    request({url:`${DELETE_VIEWSFEEDBACK}${data.original.id}`,method:"delete"}).then(res=>{
      console.log(res);
      viewsandFeedback();
    }).catch(error=>{
console.log(error);
    });
    }


    const handleClickOpen = () => {
      setOpen(true);
        
    };
    
    const handleClose = () => {
      setOpen(false);
      
    
    };
    
    const handleAddClose =()=>{
      setOpen(false);
      reset()
    }
    const handleSnackbarClose = () => {
      setOpenSnackbar(false);
    };


    const viewsandFeedback=() =>{
      axios.get(BASE_URL+GET_VIEWSFEEDBACK_DETAILS)
      .then((res)=>{
          setResponse(res.data)
          // setDateres(res.data.map((item) => item.herosectiondescription))
          console.log("step 1" +res.data.data);
          console.log("step 2" +JSON.stringify(res.data) );
          console.log("step 3" +res);
      })
      .catch((e) =>{
          console.log(e)
          // console.log('tinymce:', tinymce);
  
      }) 
  }
  useEffect(()=>{
    viewsandFeedback();
  },[])
  
    const columns = useMemo(
      (rowData) => [
        {
          accessorKey:'id',
          header:'Id',
          enableHiding:false
        },
        {
          accessorKey: 'rating',
          header: 'Rating',
          accessorFn:(row)=>row?row.rating:''
        
        },
        {
            accessorKey: 'feedBack',
            header: 'Feed Back',
            accessorFn:(row)=>row?row.feedBack:''
          
          },
          {
            accessorKey: 'name',
            header: 'Name',
            accessorFn:(row)=>row?row.name:''
          
          },
          {
            accessorKey: 'designation',
            header: 'Designation',
            accessorFn:(row)=>row?row.designation:''
          
          },
       
      
        ],
      []
    );
    return (
      
      <div className="mt-3">
      <Button variant="contained"  style={{float:'left',marginTop:20,marginLeft:20}} onClick={handleClickOpen}>
     Add
   </Button>
   <Snackbar
  open={openSnackbar}
  autoHideDuration={6000}
  onClose={handleSnackbarClose}
  anchorOrigin={{
    vertical: 'top',
    horizontal: 'center'
  }}
  style={{width:"100%"}}
>
      <MuiAlert severity="error" onClose={handleSnackbarClose} style={{ width: '50%' }}>
        {errorMessage}
      </MuiAlert>
    </Snackbar>
   <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title"   fullWidth
maxWidth="md">
     <DialogTitle id="draggable-dialog-title">ADD</DialogTitle>
     <DialogContent>
     <Form onSubmit={handleSubmit(handleAddSubmit)}>
     <Form.Group>
     <Controller
  name="rating"
  control={control}
  defaultValue=""
  rules={{
    required: { value: true, message: 'Rating is required' },
    pattern: {
      value: /^[1-5]$/,
      message: 'Rating should be a number between 1-5',
    },
    minLength: { value: 1, message: 'Rating should be at least 1 characters long' },
    maxLength: { value: 1, message: 'Rating should not exceed 1 characters' },
  }}
  // validate={value => value.trim()}
  render={({ field }) => (
    <TextField
      fullWidth
      {...field}     
      label="Rating"
      margin='dense'
      error={Boolean(errors?.rating?.message)}
      helperText={errors?.rating?.message}
     
    />
  )}
/>
         </Form.Group>
         <Form.Group>
         <Controller
  name="feedBack"
  control={control}
  defaultValue=""
  rules={{
    required: { value: true, message: 'FeedBack is required' },
    // pattern: {
    //   value: /^[a-zA-Z]+(?:\s+[a-zA-Z]+)*$/,
    //   message: 'FeedBack should contain only alphabetic characters',
    // },
    validate: {
      hasNoWhitespace: value => value.trim() !== '' || 'Name is required',
    },
    
    minLength: { value: 3, message: 'FeedBack should be at least 3 characters long' },
   
  }}
  // validate={value => value.trim()}
  render={({ field }) => (
    <TextField
      fullWidth
      {...field}     
      label="FeedBack"
      margin='dense'
      error={Boolean(errors?.feedBack?.message)}
      helperText={errors?.feedBack?.message}
     
    />
  )}
/>
         </Form.Group>
              
     
         <Form.Group>
         <Controller
  name="name"
  control={control}
  defaultValue=""
  rules={{
    required: { value: true, message: 'Name is required' },
    pattern: {
      value: /^[a-zA-Z]+(?:\s+[a-zA-Z]+)*$/,
      message: 'Name should contain only alphabetic characters',
    },
    minLength: { value: 3, message: 'Name should be at least 3 characters long' },
    maxLength: { value: 50, message: 'Name should not exceed 50 characters' },
   
  }}
  // validate={value => value.trim()}
  render={({ field }) => (
    <TextField
      fullWidth
      {...field}     
      label="Name"
      margin='dense'
      error={Boolean(errors?.name?.message)}
      helperText={errors?.name?.message}
     
    />
  )}
/>
         </Form.Group>
         <Form.Group>
         <Controller
  name="designation"
  control={control}
  defaultValue=""
  rules={{
    required: { value: true, message: 'Designation is required' },
    // pattern: {
    //   value: /^[a-zA-Z]+(?:\s+[a-zA-Z]+)*$/,
    //   message: 'Designation should contain only alphabetic characters',
    // },
    validate: {
      hasNoWhitespace: value => value.trim() !== '' || 'Designation is required',
    },
    minLength: { value: 3, message: 'Designation should be at least 3 characters long' },
   
  }}
  // validate={value => value.trim()}
  render={({ field }) => (
    <TextField
      fullWidth
      {...field}     
      label="Designation"
      margin='dense'
      error={Boolean(errors?.designation?.message)}
      helperText={errors?.designation?.message}
     
    />
  )}
/>
         </Form.Group>
         <DialogActions>
     <Button onClick={handleAddClose}>Cancel</Button>
 <Button type="submit" color="primary" >
   Submit
 </Button>
     </DialogActions>
       </Form>

     </DialogContent>
     
   </Dialog>
        <MaterialReactTable 
   columns={columns} 
   data={response}
   editingMode="row"
   enableEditing
   initialState={{ columnVisibility: { id: false } }}
   enableRowActions
   enableColumnFilters={false}

   onEditingRowSave={handleSaveRow}

   renderRowActionMenuItems={({ row }) => [
    
 
      <IconButton color="error" onClick={() => handleDelete(row)} >
        <Delete />  &nbsp;&nbsp;&nbsp;<Typography> Delete</Typography>
       </IconButton>
   
   ]}
   
   />

    
   </div>
    );
  };

export default ViewsFeedback